module.exports = __webpack_public_path__ + "static/media/visure-card.4f3b3712.png";